module.exports = __webpack_public_path__ + "static/media/12.d8206e11.jpg";